import { useWsmFeeListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmFeeListPage from "../components/WsmFeeListPage/WsmFeeListPage";

const PAGINATE_BY = 20;

export const WsmFeeListView = () => {
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmFeeListQuery({
    variables: {
      ...paginationState,
      filter: query ? { search: query } : {},
    },
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmFees?.pageInfo,
    paginationState,
  );

  return (
    <WsmFeeListPage
      fees={loading ? undefined : (mapEdgesToItems(data?.wsmFees) ?? [])}
      query={query}
      settings={{ rowNumber }}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onUpdateListSettings={(key, value) => {
        if (key === "rowNumber") {
          setRowNumber(value as number);
        }
      }}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmFeeListView;
